import axios from "axios";
import {APP_DISPLAY_ADS_API_ENDPOINT} from "../../../../../constants/api_urls";
import {getUserToken} from "../../../../../utils/functions/userToken";

export const validateImage = async (category, url) => {
    switch (category) {
        case 'images':
            return await validateLandscapeImg(url);
        case 'logo':
            return await validateLogoImg(url);
        default:
            return { success: false, error: 'Unknown category' };
    }
};

export const validateLandscapeImg = async (assetContent) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/ads-creative/validate-one-marketing-image/`,
            { assetContent: assetContent },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateLogoImg = async (assetContent) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/campaign-validator/ads-creative/validate-one-logo-image/`,
            { assetContent: assetContent },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};
